var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import SFTooltip from '../SFTooltip';
import styled from 'styled-components';
var Contain = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var Value = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-block;\n  vertical-align: middle;\n  width: ", ";\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n"], ["\n  display: inline-block;\n  vertical-align: middle;\n  width: ", ";\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n"])), function (props) { return props.width || null; });
var SFAutoEllipsis = function (_a) {
    var _b = _a.tooltip, tooltip = _b === void 0 ? false : _b, _c = _a.value, value = _c === void 0 ? '' : _c, _d = _a.width, width = _d === void 0 ? '100%' : _d, tooltipStyle = _a.tooltipStyle, always = _a.always, children = _a.children, props = __rest(_a, ["tooltip", "value", "width", "tooltipStyle", "always", "children"]);
    var _e = useState(false), isShow = _e[0], setIsShow = _e[1];
    var element = useRef(null);
    useEffect(function () {
        if (element.current === null)
            return;
        var newValue = element.current.scrollWidth > element.current.offsetWidth;
        if (isShow !== newValue)
            setIsShow(newValue);
    }, [value]);
    return (_jsx(Contain, __assign({ className: "sf-auto-contain", style: tooltipStyle }, { children: _jsx(SFTooltip, __assign({ className: "tooltip", title: tooltip && (always || isShow) ? String(value) : '' }, { children: _jsx(Value, __assign({ ref: element, width: width }, props, { children: children || value })) })) })));
};
export default SFAutoEllipsis;
var templateObject_1, templateObject_2;
